<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-20">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"> </i>
          </div>
          <div>
            <h2
              class="clean-section-title has-text-white has-text-weight-bold is-paddingless"
            >
              خدمات الموبي كاش
            </h2>
            <h3
              class="subtitle is-5 pt-10 pb-10 has-text-white has-text-weight-bold"
            >
              تمكنك من الاشتراك بخدمة الشراء عن طريق الهاتف النقال (موبي كاش).
            </h3>
          </div>
        </div>
        <h2></h2>
        <div class="columns is-vcentered s">
          <div class="column">
            <div
              class="flex-card icon-card-hover mobicash-card light-bordered padding-20"
              @click="makeRequest('بطاقة موبي كاش جديدة', 10)"
            >
              <h3 class="card-title has-text-link">طلب بطاقة موبي كاش جديدة</h3>
              <p class="card-description">
                بناء على اشتراك بخدمة الصحارى موبايل ، فإنه يمكنك التقدم بطلب
                الحصول على البطاقة الخاصة بخدمة موبي كاش ، وذلك من خلال هذا
                البند ، حيث تمكنك هذه الخدمة من إتمام عمليات شراء مقتنياتك من
                المحال التجارية ومراكز الخدمات المشتركة بالخدمة ، وذلك من خلال
                استخدام هاتفك المحمول .
              </p>
            </div>
          </div>
          <div class="column">
            <div
              class="flex-card icon-card-hover mobicash-card light-bordered padding-20"
              @click="makeRequest(' إيقاف موبي كاش', 11)"
            >
              <h3 class="card-title has-text-link is-clean">
                طلب إيقاف موبي كاش
              </h3>
              <p class="card-description">
                بناء على إشتراكك مسبقا بخدمة ( موبي كاش ) الخاصة بزبائن مصرف
                الصحارى ، ولسببٍ ما قد ترغب في إلغاء الإشتراك ، لذا فإنه يمكنك من
                هنا إلغاء الإشتراك بالخدمة ، آملين منك ذكر السبب ليتسنى لنا
                النظر في ذلك .
              </p>
            </div>
          </div>
          <div class="column">
            <div
              class="flex-card icon-card-hover mobicash-card light-bordered padding-20"
              @click="makeRequest('تجديد الرقم السري لموبي كاش ', 12)"
            >
              <h3 class="card-title has-text-link is-clean">
                اصدار موبي كاش بدل فاقد
              </h3>
              <p class="card-description">
                بناء على إشتراكك بخدمة ( موبي كاش ) ، يمكنك العمل على تغيير
                الرقم السري الخاص بك .
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
      >
        <router-link to="/portal">
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
            <b>عودة للرئيسية</b>
          </a>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "mobiecash",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "mobi/newRequest",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: null,
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequest",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
  },
};
</script>
